/*
 * @Author: 师辉辉 a971173888@163.com
 * @Date: 2022-11-07 08:43:38
 * @LastEditors: bianbinbin
 * @LastEditTime: 2026-06-03 14:39:13
 * @FilePath: /ejx-web/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import permission from './directive/permission'
import style from './directive/style'
import store from '@/store'
import Cookie from 'js-cookie'
// 原生插件
import MXNativeAPI from './plugins/mx-libs/index.umd.min.js'
import NProgress from 'nprogress'
import CountTo from 'vue-count-to'
Vue.component('b-count', CountTo)
import 'nprogress/nprogress.css'

import controller from '@/utils/common/controller'

// 设置token
import { setAuthorization } from '@/utils/request'
import { getQueryString } from '@/utils/xl_utils'
// const token = getQueryString('token')
const token = Cookie.get('token')
if (token) {
  // 设置二级域名访问状态，成功登录其他系统
  document.cookie = `TGC=${token.split(':')[1]}; path=/; domain=juneyaoair.com`
  // 设置cookie
  setAuthorization({ token })
}

// 移动端适配
import 'amfe-flexible'
// 引入UI（按需引入组件）
import '@/plugins/vant'
// 国际化
import i18n from './i18n/index'
// 引入normalize.css
import 'normalize.css/normalize.css'
import '@/utils/rem' //在main.js中引入rem.js
import { px2rem } from '@/utils/rem'

import 'swiper/swiper-bundle.css'
import 'animate.css'

import { ImagePreview } from 'vant'

// px 转 rem
Vue.prototype.$px2rem = px2rem // 放到全局
// import device from '@/utils/common/device'

Vue.directive('html-image-preview', {
  bind(el) {
    const handleClick = e => {
      const { src, tagName = '' } = e.target
      if (tagName.toLowerCase() === 'img' && src) {
        ImagePreview({
          images: [src],
          closeable: true,
          showIndex: false,
          maxZoom: 10,
          onClose: () => {
            Vue.prototype.$native.api.statusBarColor([255, 255, 255, 1]) // 恢复状态栏颜色
          }
        })
        Vue.prototype.$native.api.statusBarColor([25, 25, 25, 1])
      }
    }
    el.addEventListener('click', handleClick)
    el._handleClick = handleClick
  },
  unbind(el) {
    el.removeEventListener('click', el._handleClick)
    delete el._handleClick
  }
})

// 处理移动端click事件300毫秒延迟
// import FastClick from 'fastclick'
// FastClick.prototype.focus = function (targetElement) {
//   var length
//   //兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError
//   //这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
//   if (
//     device.ios &&
//     targetElement.setSelectionRange &&
//     targetElement.type.indexOf('date') !== 0 &&
//     targetElement.type !== 'time' &&
//     targetElement.type !== 'month' &&
//     targetElement.type !== 'email'
//   ) {
//     length = targetElement.value.length
//     targetElement.setSelectionRange(length, length)
//     /*修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘*/
//     targetElement.focus()
//   } else {
//     targetElement.focus()
//   }
// }
// FastClick.attach(document.body)
// 图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import { handleRequest } from '@/utils/xl_utils.js'
import { isVconsoleEnabled } from '@/utils/vconsoleConfig'

import Vconsole from 'vconsole'
// 根据 Cookie vconsole_enabled 控制（domain=juneyaoair.com，各子域 H5 共用）
if (isVconsoleEnabled()) {
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}
// 只有当 localStorage 中的值为 'Y' 时才启用 vConsole
// if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'uat') {
//   const vConsole = new Vconsole()
//   Vue.use(vConsole)
// }
// // 高德地图
// import VueAmap from 'vue-amap'
// Vue.use(VueAmap)
// 商品瀑布流
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
// 图片裁剪
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.use(permission)
Vue.use(style)

// 时间插件
import moment from 'moment'
import * as filters from '@/utils/filters'
Vue.prototype.$moment = moment

// 原生H5页面跳转交互
Vue.prototype.$controller = controller

Vue.prototype.$native = new MXNativeAPI({
  // cordovaPath 默认为 cordova.js
  // 远端部署时可以进行调整
  cordovaPath: 'cordova/cordova.js'
})

// 引入全部样式
// import 'vant/lib/index.less'

// 引入单个组件样式
// import 'vant/lib/button/style/less'

// 修改主题
document.body.className = 'theme-parent'

Vue.prototype.$response = handleRequest

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

// 用户信息加载状态
let userInfoReadyPromise = null

// 等待设备ready
function whenDeviceReady() {
  return new Promise(resolve => {
    if (window.cordova) {
      document.addEventListener('deviceready', resolve, { once: true })
    } else {
      resolve()
    }
  })
}

// 加载用户信息
async function loadUserInfo() {
  await whenDeviceReady()
  const res = await Vue.prototype.$native.api.getUserInfo()
  const tgc = Cookie.get('TGC') || getQueryString('token')
  if ((tgc !== '' && tgc !== null) || tgc !== undefined || tgc !== 'undefined') {
    Cookie.set('TGC', tgc)
  }
  const { user, permissions, resource, roles } = JSON.parse(res) || {}
  const userInfo = {
    user,
    permissions,
    resource,
    roles,
    tgc
  }
  console.log('原生api获取的用户信息:', user)
  await store.dispatch('setUserInfo', userInfo)
}

// 确保用户信息已加载
function ensureUserInfoReady() {
  if (!userInfoReadyPromise) {
    userInfoReadyPromise = loadUserInfo().catch(err => {
      console.error(err)
      userInfoReadyPromise = null
    })
  }
  return userInfoReadyPromise
}

// 首次加载时获取用户信息
ensureUserInfoReady()

// 路由钩子函数
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title
  }
  if (to.query.windowType === 'small') {
    const token = to.query.token
    Cookie.set('token', token)
    setAuthorization({ token })
    next()
    return
  }
  // 下载页面放行
  if (to.fullPath.includes('downloadApp') || to.fullPath.includes('downloadFlyApp')) {
    next()
    return
  }
  // 确保用户信息已加载
  await ensureUserInfoReady()
  next()
})

router.afterEach(() => {
  // 关闭进度条
  NProgress.done()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
